import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RespostasDoSgaState {
  codigoAssociado: string | null;
  codigoVeiculo: string | null;
  codigoEmissao: string | null;
  codigoTermo: string | null;
}

const initialState: RespostasDoSgaState = {
  codigoAssociado: null,
  codigoVeiculo: null,
  codigoEmissao: null,
  codigoTermo: null,
};

const respostasDoSgaSlice = createSlice({
  name: 'respostasDoSga',
  initialState,
  reducers: {
    setCodigoAssociado: (state, action: PayloadAction<string>) => {
      state.codigoAssociado = action.payload;
    },
    setCodigoVeiculo: (state, action: PayloadAction<string>) => {
      state.codigoVeiculo = action.payload;
    },
    setTermoInfo: (state, action: PayloadAction<{ codigoEmissao: string; codigoTermo: string }>) => {
      state.codigoEmissao = action.payload.codigoEmissao;
      state.codigoTermo = action.payload.codigoTermo;
    },
    resetRespostasDoSga: () => initialState,
  },
});

export const { setCodigoAssociado, setCodigoVeiculo, setTermoInfo, resetRespostasDoSga } = respostasDoSgaSlice.actions;
export default respostasDoSgaSlice.reducer;
